import { Dispatch } from 'redux'

import NotificationInterface from '../../interfaces/client/Notification'

import {
  addNotification,
  removeNotification,
} from '../../actions/notifications'

import { buildInfantDateOfBirthError } from '../../utils/notifications'

export default (
  targetElement: HTMLInputElement,
  passengerId: string,
  infantDateOfBirthValidator: Function,
  dispatch: Dispatch,
  dateOfBirthError?: NotificationInterface
) => {
  const inputValueMatchesThePattern = targetElement.checkValidity()

  if (!inputValueMatchesThePattern && !dateOfBirthError) return

  const isValidDateOfBirth = infantDateOfBirthValidator(targetElement.value)

  if (!isValidDateOfBirth && !dateOfBirthError) {
    const customErrorNotification = buildInfantDateOfBirthError(passengerId)

    dispatch(addNotification(customErrorNotification))
    return
  }

  if (dateOfBirthError) {
    dispatch(removeNotification(dateOfBirthError.id))
  }
}
